/**
 * How a school reads in a picker: "Lincoln Elementary (Stockton)".
 *
 * The district has several Lincolns and Roosevelts, so the bare name cannot
 * tell them apart and the city is what makes the choice safe. This mirrors
 * School#display_name on the Rails side, which every server-rendered school
 * dropdown already uses.
 *
 * ONE implementation on purpose: this label was written inline in two React
 * pickers, and the copies drifted -- the CSV import screen kept showing bare
 * names long after the confirms screen had cities. Import it; never re-inline
 * the template literal.
 *
 * A school with no city falls back to the name alone, never a dangling "( )".
 */
export const schoolOptionLabel = (school) => (
  school && school.cityName ? `${school.name} (${school.cityName})` : (school && school.name)
);

export default schoolOptionLabel;
